export default __webpack_public_path__ + "static/media/undraw_Birthday_cake_2wxy.5731259a.svg";